// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"D3-z","button":"E3-z","disabled":"F3-z","creditCard":"G3-z","wrapper":"H3-z"};